import { render, staticRenderFns } from "./ManufacturerDevicesTab.vue?vue&type=template&id=3b33417c"
import script from "./ManufacturerDevicesTab.vue?vue&type=script&lang=js"
export * from "./ManufacturerDevicesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports